import { convertVolume } from "./convertVolume";

export async function parseCsv(file, units) {
  try {
    let data = [];
    let production = {};

    data = file.split('\r\n');
    
    let headers = data.splice(0,1)[0];
    headers = headers.split(",");

    let colIndices = {
      uwi: undefined,
      date: undefined,
      oil: undefined,
      gas: undefined,
      condensate: undefined,
      water: undefined,
    };

    headers.forEach((col,i) => { // find indices of columns in the headers
      if (col.match(/id/ig) || col.match(/uwi/ig))  colIndices.uwi = i;
      if (col.match(/date/ig)) colIndices.date = i;
      if (col.match(/oil/ig)) colIndices.oil = i;
      if (col.match(/gas/ig)) colIndices.gas = i;
      if (col.match(/condensate/ig)) colIndices.condensate = i;
      if (col.match(/water/ig)) colIndices.water = i;
    });

    let wellUwis = []; // list of uwis in the file

    data.forEach(d => {
      let row = d.split(',');
      if (row[colIndices.uwi]?.length > 0 && wellUwis.indexOf(row[colIndices.uwi]) === -1) wellUwis.push(row[colIndices.uwi]);
    });

    wellUwis.forEach(uwi => {
      let wellProduction = {
        byFluid: {},
        fluids: []
      };

      const wellProductionData = data.filter(d => d.includes(uwi));

      ['oil', 'gas', 'condensate', 'water'].forEach(fluid => {
        if (colIndices[fluid]) {
          let fluidProduction = [];
          let startDate = undefined;
          // const startDate = new Date(data[0].split(",")?.[colIndices.date]);
          for (let i = 0; i < wellProductionData.length; i++) {
            let monthlyData = wellProductionData[i].split(",");
            
            if (monthlyData[colIndices.uwi] === uwi) {
              if (!startDate) {
                if (monthlyData[colIndices.date]) {
                  startDate = new Date(monthlyData[colIndices.date]);
                } else {
                  startDate = new Date();
                };
              };
              if (startDate.getDate() === 27 || startDate.getDate() === 28 || startDate.getDate() === 29 || startDate.getDate() === 30 || startDate.getDate() === 31) {
                startDate.setDate(2);
                startDate.setMonth(startDate.getMonth() + 1);
              };
              startDate = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), 2));

              let currDate = new Date(monthlyData[colIndices.date]);
              if (currDate.getDate() === 27 || currDate.getDate() === 28 || currDate.getDate() === 29 || currDate.getDate() === 30 || currDate.getDate() === 31) {
                currDate.setDate(2);
                currDate.setMonth(currDate.getMonth() + 1);
              };
              currDate = new Date(Date.UTC(currDate.getFullYear(), currDate.getMonth(), 2));
              
              if (!monthlyData[colIndices.date] || !currDate) {
                currDate = new Date(new Date(startDate)?.setMonth(startDate?.getMonth() + i));
              };

              const monthsOnline = (monthDiff(startDate, currDate) + 1) || (i + 1);
              const monthlyVolume = convertVolume(Number(monthlyData[colIndices[fluid]]), units, fluid);
              let monthlyProduction = {
                date: currDate?.toISOString()?.split("T")?.[0],
                monthsOnline: monthsOnline,
                volume: monthlyVolume,
                cumVolume: i === 0 ? monthlyVolume : (fluidProduction[i-1]?.cumVolume + monthlyVolume)
              };
              fluidProduction.push(monthlyProduction);
            };
          };
          if (fluidProduction[fluidProduction.length - 1]?.cumVolume > 0) { // if well has fluid production
            wellProduction.byFluid = {...wellProduction.byFluid, [fluid]: fluidProduction};
            if (wellProduction.fluids.indexOf(fluid) === -1) wellProduction.fluids.push(fluid);
          };
        };
      });
      production[uwi] = wellProduction;
    });

    return production;
  } catch (error) {
    console.log(error);
    return null;
  };
};

// FUNCTIONS
function monthDiff(d1, d2) {
  try {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return Math.abs(months);
  } catch (error) {
    console.log(error);
    return 0;
  };
};
